import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import RoleSubMenuFields from './RoleSubMenuFields'

export const RoleSubMenuCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <RoleSubMenuFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default RoleSubMenuCreate
